import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WorkOrderService } from './services/work-order.service';
import { AuthGuard } from './services/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { TaskSuccessComponent } from './components/task-success/task-success.component';
import { WorkOrderComponent } from './components/work-order/work-order.component';
import { ErrorComponent } from './components/error/error.component';
import { ListComponent } from './components/list/list.component';
import { CheckTokenComponent } from './components/check-token/check-token.component';


const routes: Routes = [
  { path: 'home', component: WorkOrderComponent, canActivate : [AuthGuard] },
  { path: 'list', component: ListComponent, canActivate : [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'task-success', component: TaskSuccessComponent , canActivate : [AuthGuard]},
  { path: 'error', component: ErrorComponent , canActivate : [AuthGuard]},
  { path: 'check-token', component: CheckTokenComponent , canActivate : [AuthGuard]},
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
